// Portado de maxpro_app/src/services/bluetooth/helpers/knob-resistance.ts
// Convierte el peso (kg) de cada rep al nivel de knob (0–25) para poder
// agrupar reps de FreeStyle en "ejercicios" igual que la app.

/** V1 = MAXPRO Legacy, V2 = MAXPRO Air */
const KNOB_RESISTANCE_LEGACY = [
  { level: 1, kg: 3.0 },
  { level: 2, kg: 3.6 },
  { level: 3, kg: 4.1 },
  { level: 4, kg: 4.5 },
  { level: 5, kg: 5.0 },
  { level: 6, kg: 5.5 },
  { level: 7, kg: 6.4 },
  { level: 8, kg: 7.7 },
  { level: 9, kg: 9.1 },
  { level: 10, kg: 10.0 },
  { level: 11, kg: 12.7 },
  { level: 12, kg: 15.0 },
  { level: 13, kg: 17.3 },
  { level: 14, kg: 20.0 },
  { level: 15, kg: 23.6 },
  { level: 16, kg: 27.3 },
  { level: 17, kg: 30.9 },
  { level: 18, kg: 35.5 },
  { level: 19, kg: 40.0 },
  { level: 20, kg: 45.5 },
  { level: 21, kg: 50.9 },
  { level: 22, kg: 56.4 },
  { level: 23, kg: 62.3 },
  { level: 24, kg: 67.3 },
  { level: 25, kg: 71.8 },
];

const KNOB_RESISTANCE_AIR = [
  { level: 1, kg: 1.4 },
  { level: 2, kg: 1.6 },
  { level: 3, kg: 1.8 },
  { level: 4, kg: 2.0 },
  { level: 5, kg: 2.5 },
  { level: 6, kg: 3.0 },
  { level: 7, kg: 4.5 },
  { level: 8, kg: 5.5 },
  { level: 9, kg: 7.0 },
  { level: 10, kg: 10.0 },
  { level: 11, kg: 13.0 },
  { level: 12, kg: 15.0 },
  { level: 13, kg: 18.0 },
  { level: 14, kg: 21.0 },
  { level: 15, kg: 25.0 },
  { level: 16, kg: 28.0 },
  { level: 17, kg: 31.0 },
  { level: 18, kg: 34.0 },
  { level: 19, kg: 37.0 },
  { level: 20, kg: 40.0 },
  { level: 21, kg: 43.0 },
  { level: 22, kg: 47.0 },
  { level: 23, kg: 50.0 },
  { level: 24, kg: 53.0 },
  { level: 25, kg: 57.0 },
];

function getKnobResistanceTable(deviceVersion) {
  return deviceVersion === "V2" ? KNOB_RESISTANCE_AIR : KNOB_RESISTANCE_LEGACY;
}

/**
 * Inversa de getKnobKg: convierte peso (kg) a nivel de knob (0–25) con
 * interpolación de décimas entre niveles. Misma lógica que la app.
 */
export function getKnobFromKg(weight, deviceVersion) {
  const w = Number(weight);
  if (!Number.isFinite(w) || w <= 0) return 0;

  const table = getKnobResistanceTable(deviceVersion);
  const maxEntry = table[table.length - 1];
  if (w >= maxEntry.kg) return maxEntry.level;

  for (let i = 0; i < table.length - 1; i++) {
    const current = table[i];
    const next = table[i + 1];
    if (w >= current.kg && w < next.kg) {
      const increment = (next.kg - current.kg) / 10;
      const knobIncrement = (w - current.kg) / increment;
      return Number((current.level + knobIncrement * 0.1).toFixed(1));
    }
  }

  return 0;
}
